import Box from '@mui/material/Box'
import grey from '@mui/material/colors/grey'
import Typography from '@mui/material/Typography'

export default function Terms() {
  return (
    <Box p={15} pt={0} maxWidth={'1320px'} margin={'0 auto'}>
      <Typography variant={'h4'} color={grey[700]} mt={5} mb={3}>
        TCF Terms of Service
      </Typography>
      <Box>
        <Typography variant={'h6'} color={grey[700]} fontWeight={600} mb={1}>
          Terms of Use
        </Typography>
        <Typography>
          The following terms and conditions govern all use of the https://www.iscout.ai website and
          all content, services and products available at or through the website
          (&ldquo;iScout&rdquo;). The website is owned and operated by Third Coast Federal, Inc.
          (&quot;Third Coast&quot;) and our licensors. The IScout is offered subject to your
          acceptance without modification of all of the terms and conditions contained herein, the
          iScout Privacy Policy and Cookie Statement available on iScout website, and any iScout
          Subscription Agreement between you and Third Coast (collectively, the
          &quot;Agreement&quot;).
        </Typography>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c0'>
            Please read this Agreement carefully before accessing or using iScout. By accessing or
            using any part of the website, you agree to become bound by the terms and conditions of
            this Agreement. If you do not agree to all the terms and conditions of this Agreement,
            then you may not access iScout or use any Third Coast website or services. If these
            terms and conditions are legally considered an offer by Third Coast, acceptance is
            expressly limited to these terms. The website is available only to individuals who are
            at least 18 years old.
          </span>
        </p>
        <p className='c10'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Your iScout Account</span>
          <span className='c0'>
            . If you create an iScout user account or one is otherwise provisioned to you, you are
            responsible for maintaining the security of your user account and your content
            contributions and comments created using that user account, and you are fully
            responsible for all activities that occur under the account and any other actions taken
            in connection with those content contributions and comments. You must not describe,
            assign tags or categories to your content contributions or comments, or otherwise enter
            or upload any information that is misleading or unlawful, including in a manner intended
            to trade on the name or reputation of others, and we may change or remove any
            description or keyword that it considers inappropriate or unlawful, or otherwise likely
            to cause us any liability. You must immediately notify us of any unauthorized uses of
            your user account, your content contributions, your comments, or any other breaches of
            security. Third Coast will not be liable for any acts or omissions by you, including any
            damages of any kind incurred as a result of your acts or omissions.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Responsibility of Contributors</span>
          <span className='c0'>
            . If you provide content contributions, provide comments, comment on content
            contributions, post material to the website, post links on iScout, or otherwise make (or
            allow any third party to make) material available by means of iScout (any such material,
            &quot;Content&quot;), You are entirely responsible for the content of, and any harm
            resulting from, that Content. That is the case regardless of whether the Content in
            question constitutes text, graphics, an audio file, or computer software. By making
            Content available, you represent and warrant that:
          </span>
        </p>
        <ul className='c2 lst-kix_list_1-0 start'>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              downloading, copying and using the Content will not infringe any party&#39;s
              proprietary rights, including but not limited to copyright, patent, trademark,
              confidentiality or trade secret rights;
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              if your employer has rights to intellectual property you create, you have either (i)
              received permission from your employer to post or make available the Content,
              including but not limited to any software, or (ii) secured from your employer a waiver
              as to all rights in or to the Content;
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              you have fully complied with any third-party licenses relating to the Content, and
              have done all things necessary to successfully pass through any required terms of
              those license to anyone who may use the Content;
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              the Content does not contain or install any viruses, worms, malware, Trojan horses or
              other harmful or destructive content;
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              the Content is not spam, is not machine- or randomly-generated, and does not contain
              unethical or unwanted commercial content designed to drive traffic to third party
              sites or boost the search engine rankings of third party sites, or to further unlawful
              acts (such as phishing) or mislead recipients as to the source of the material (such
              as spoofing);
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              the Content is not obscene, libelous or defamatory, hateful or racially or ethnically
              objectionable, and does not violate the privacy or publicity rights of any third
              party;
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              your Content or user account is not named in a manner that misleads your readers into
              thinking that you are another person or company. For example, your user name not the
              name of a person other than yourself or company other than your own; and
            </span>
          </li>
          <li className='c4 c8 li-bullet-0'>
            <span className='c6'>
              you have, in the case of Content that includes computer code, accurately categorized
              and/or described the type, nature, uses and effects of the materials, whether
              requested to do so by Third Coast or otherwise.
            </span>
          </li>
        </ul>
        <p className='c10'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c0'>
            By submitting Content to generally accessible areas of iScout or for general
            dissemination via iScout (including, without limitation, needs, challenges, calendar
            events, community posts, community opportunity boards, and business or individual
            profile pages), you grant Third Coast a world-wide, royalty-free, and non-exclusive
            license to reproduce, modify, adapt and publish the Content for the use of visitors to
            or members of iScout and other exchanges in the Ratio Companies Exchange network.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c0'>
            Without limiting any of your representations or warranties, Third Coast has the right
            (though not the obligation) to, in Third Coast&#39;s sole discretion (i) refuse or
            remove any content that, in Third Coast&#39;s reasonable opinion, violates any law,
            regulation or Third Coast policy or is in any way harmful or objectionable, or (ii)
            terminate or deny access to and use of the Third Coast to any individual or entity for
            any reason, in Third Coast&#39;s sole discretion. Third Coast will have no obligation to
            provide a refund of any amounts previously paid.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Responsibility of iScout Users/Visitors</span>
          <span className='c0'>
            . Third Coast has not reviewed, and cannot review, all of the material, including
            computer software, posted to iScout, and cannot therefore be responsible for that
            material&#39;s content, use or effects. By operating iScout, Third Coast does not
            represent or imply that it endorses the material there posted, or that it believes such
            material to be accurate, useful or non-harmful. You are responsible for taking
            precautions as necessary to protect yourself and your computer systems from viruses,
            worms, Trojan horses, and other harmful or destructive content. iScout and related
            applications may contain content that is offensive, indecent, or otherwise
            objectionable, as well as content containing technical inaccuracies, typographical
            mistakes, and other errors. IScout or related sites may also contain material that
            violates the privacy or publicity rights, or infringes the intellectual property and
            other proprietary rights, of third parties, or the downloading, copying or use of which
            is subject to additional terms and conditions, stated or unstated. Third Coast disclaims
            any responsibility for any harm resulting from the use by visitors of the website, or
            from any downloading by those visitors of Content there posted.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Disclaimer of Accuracy</span>
          <span>
            . iScout and related sites contain data and information secured from third party sources
            such{' '}
          </span>
          <span className='c9'>
            <a
              className='c5'
              href='https://www.google.com/url?q=http://www.sam.gov&amp;sa=D&amp;source=editors&amp;ust=1729274290098474&amp;usg=AOvVaw364vnigW5Q7fBPeFz-5Opz'
            >
              www.SAM.gov
            </a>
          </span>
          <span>, </span>
          <span className='c9'>
            <a
              className='c5'
              href='https://www.google.com/url?q=http://www.fpds.gov&amp;sa=D&amp;source=editors&amp;ust=1729274290098579&amp;usg=AOvVaw10EXL6yFYfhSk7ZdFb2ZzG'
            >
              www.fpds.gov
            </a>
          </span>
          <span>, </span>
          <span className='c9'>
            <a
              className='c5'
              href='https://www.google.com/url?q=http://www.usaspending.gov&amp;sa=D&amp;source=editors&amp;ust=1729274290098650&amp;usg=AOvVaw1lO8zR1pAE3v8Ky_uSaStc'
            >
              www.usaspending.gov
            </a>
          </span>
          <span>, </span>
          <span className='c9'>
            <a
              className='c5'
              href='https://www.google.com/url?q=http://www.sbir.gov&amp;sa=D&amp;source=editors&amp;ust=1729274290098711&amp;usg=AOvVaw3ds8TULB7iPZAxmKKEQ7pK'
            >
              www.sbir.gov
            </a>
          </span>
          <span>, </span>
          <span className='c9'>
            <a
              className='c5'
              href='https://www.google.com/url?q=http://www.grants.gov&amp;sa=D&amp;source=editors&amp;ust=1729274290098775&amp;usg=AOvVaw3RauuL2KwDJoPH0E5jpRoL'
            >
              www.grants.gov
            </a>
          </span>
          <span className='c0'>
            , the Dynamic Small Business Search (DSBS), the USPTO patent database, and from other
            publicly accessible websites and databases. &nbsp;iScout also includes information
            submitted by iScout users. &nbsp;Third Coast does not investigate the accuracy of such
            information, and the user acknowledges that those data sources may contain inaccuracies
            or errors. The information and confirmation provided by or through iScout is for
            information purposes only and should not be considered a recommendation by Third Coast
            with respect any contacts, contracts, business opportunities or other awards. THIRD
            COAST EXPRESSLY DISCLAIMS ANY RESPONSIBILITY FOR DECISIONS MADE, IN WHOLE OR IN PART, ON
            THE BASIS OF ANY INFORMATION CONTAINED IN, OR THE ABSENCE OF INFORMATION IN, iSCOUT AND
            RELATED SITES AND EXCHANGES.
          </span>
        </p>
        <p className='c4'>
          <span className='c0'>&nbsp; &nbsp; </span>
        </p>
        <p className='c4'>
          <span className='c1'>Content Posted on Other Websites</span>
          <span className='c0'>
            . We have not reviewed, and cannot review, all of the material, including computer
            software, made available through the websites and webpages to which iScout links, and
            that link to iScout. Third Coast does not have any control over those non-iScout apps,
            sites, services and webpages, and is not responsible for their contents or their use. By
            linking to a non-iScout app, sites, services or webpage, Third Coast does not represent
            or imply that it endorses such resources. You are responsible for taking precautions as
            necessary to protect yourself and your computer systems from viruses, worms, Trojan
            horses, and other harmful or destructive content. Third Coast disclaims any
            responsibility for any harm resulting from your use of non-iScout resources.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Copyright Infringement and DMCA Policy</span>
          <span className='c0'>
            . As Third Coast asks others to respect its intellectual property rights, it respects
            the intellectual property rights of others. If you believe that material located on or
            linked to by iScout violates your copyright, please notify Third Coast by providing a
            Digital Millennium Copyright Act (&quot;DMCA&quot;) Infringement Notice. Third Coast
            will respond to all such notices, including as required or appropriate by removing the
            infringing material or disabling all links to the infringing material. In the case of a
            user who may infringe or repeatedly infringes the copyrights or other intellectual
            property rights of Third Coast or others, Third Coast may, in its discretion, terminate
            or deny access to and use of iScout. In the case of such termination, Third Coast will
            have no obligation to provide a refund of any amounts previously paid to Third Coast.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Intellectual Property</span>
          <span className='c0'>
            . This Agreement does not transfer from Third Coast to you any Third Coast or third
            party intellectual property, and all right, title and interest in and to such property
            will remain (as between the parties) solely with Third Coast. Third Coast Federal,
            iScout, the iScout logo, and all other trademarks, service marks, graphics and logos
            used in connection with iScout, or the Third Coast Federal website and services are
            trademarks or registered trademarks of Third Coast or Third Coast&#39;s licensors or
            affiliates. Other trademarks, service marks, graphics and logos used in connection with
            iScout and related services may be the trademarks of other third parties. Your use of
            iScout grants you no right or license to reproduce or otherwise use any Third Coast or
            third-party trademarks.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Changes</span>
          <span className='c0'>
            . Third Coast reserves the right, at its sole discretion, to modify or replace any part
            of this Agreement by notifying you of the change via email at your email of record in
            iScout. Your continued use of or access to iScout following notice of any changes to
            this Agreement constitutes acceptance of those changes prospectively; provided, however
            that the changes shall not apply retroactively. Third Coast may also, in the future,
            offer new services and/or features through the website (including, the release of new
            tools and resources). Such new features and/or services shall be subject to the terms
            and conditions of this Agreement.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Termination</span>
          <span className='c0'>
            . If you wish to terminate this Agreement or your iScout account (if you have one), you
            may simply discontinue using iScout. All provisions of this Agreement which by their
            nature should survive termination shall survive termination or expiration of this
            Agreement, including, without limitation, ownership provisions, warranty disclaimers,
            indemnity and limitations of liability.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Disclaimer of Warranties</span>
          <span className='c0'>
            . iScout is provided to you &quot;as is&quot;. Third Coast and its suppliers and
            licensors hereby disclaim all warranties of any kind, express or implied, including,
            without limitation, the warranties of merchantability, fitness for a particular purpose
            and non-infringement. Neither Third Coast nor its suppliers and licensors, makes any
            warranty that iScout will be error free or that access thereto will be continuous or
            uninterrupted. You understand that you download from, or otherwise obtain content or
            services through, iScout at your own discretion and risk.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Limitation of Liability</span>
          <span className='c0'>
            . In no event will Third Coast, or its suppliers or licensors, be liable with respect to
            any subject matter of this Agreement under any contract, tort, negligence, strict
            liability or other legal or equitable theory for: (i) any special, incidental or
            consequential damages; (ii) the cost of procurement or substitute products or services;
            or (iii) for interruption of use or loss or corruption of data. Third Coast shall have
            no liability for any failure or delay due to matters beyond their reasonable control.
            The foregoing shall not apply to the extent prohibited by applicable law.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>General Representation and Warranty</span>
          <span className='c0'>
            . You represent and warrant that (i) your use of iScout will be in strict accordance
            with the Third Coast Privacy Policy, with this Agreement and with all applicable laws
            and regulations (including without limitation any local laws or regulations in your
            country, state, city, or other governmental area, regarding online conduct and
            acceptable content, and including all applicable laws regarding the transmission of
            technical data exported from or imported into the United States or the country in which
            you reside) and (ii) your use of the website will not infringe or misappropriate the
            intellectual property rights of any third party.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Indemnification</span>
          <span className='c0'>
            . You agree to indemnify and hold harmless Third Coast, its contractors, and its
            licensors, and their respective directors, officers, employees and agents from and
            against any and all claims and expenses, including attorneys&#39; fees, arising out of
            your use of iScout, including but not limited to out of your violation this Agreement.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
        <p className='c4'>
          <span className='c1'>Miscellaneous</span>
          <span className='c0'>
            . These Terms of Use, iScout Privacy Policy, the Cookie Statement, and Subscription
            Agreement (if a Subscription Agreement is executed by the parties), (collectively, the
            &ldquo;Agreement&rdquo;), constitute the entire agreement between Third Coast and you
            concerning the subject matter hereof, and they may only be modified by a written
            amendment signed by an authorized executive of Third Coast, or as otherwise provided in
            the Changes Section above. In the event of a conflict between a Subscription Agreement
            and either the Terms of Use or Privacy Policy, the Subscription Agreement terms shall be
            controlling. Except to the extent applicable law provides otherwise, this Agreement and
            any access to or use of iScout and related sites or services are governed by the laws of
            Indiana, U.S.A., excluding its conflict of law provisions, and the proper venue for any
            disputes arising out of or relating to any of the same will be the state and federal
            courts located in South Bend, Indiana. The Uniform Computer Information Transactions Act
            (UCITA) shall not apply to this Agreement. Except for claims for injunctive or equitable
            relief or claims regarding intellectual property rights (which may be brought in any
            competent court without the posting of a bond), any dispute arising under this Agreement
            shall be finally settled in accordance with the Rules of the American Arbitration
            Association (&quot;AAA&quot;) by three arbitrators appointed in accordance with such
            Rules. The arbitration shall take place in South Bend, Indiana, in the English language
            and the arbitral decision may be enforced in any court of competent jurisdiction. If any
            part of this Agreement is held invalid or unenforceable, that part will be construed to
            reflect the parties&#39; original intent, and the remaining portions will remain in full
            force and effect. A waiver by either party of any term or condition of this Agreement or
            any breach thereof, in any one instance, will not waive such term or condition or any
            subsequent breach thereof. You may assign your rights under this Agreement to any party
            that consents to, and agrees to be bound by, its terms and conditions; Third Coast may
            assign its rights under this Agreement without condition. This Agreement will be binding
            upon and will inure to the benefit of the parties, their successors and permitted
            assigns.
          </span>
        </p>
        <p className='c3'>
          <span className='c0'></span>
        </p>
      </Box>
    </Box>
  )
}
